export const AI_SECTION_CREATOR_PANEL_TYPE: string = 'section ai assistant';
export const CREATE_SECTON_WITH_AI_CACHE: string = 'createSectionWithAiCache';
export const SECTIONS_COUNT_PER_REQUEST = 3;
export const ERROR_STATE_PANEL_PATH =
  'panels.focusPanels.aiSectionCreatorErrorPanel';
export const MAX_DESCRIPTION_LENGTH = 400;
export const BUSINESS_TYPE_PANEL_ORIGIN = 'section_creator';
